module.exports = __webpack_public_path__ + "img/antes_despues_299.b06b6d57.png";